/* Wrenfold — the one motion rule and the few bits of interaction the design needs.
   Reveal logic ported from the DCLogic script in "Wrenfold Home.dc.html". */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* fade + 14px rise, 650ms, stagger 90ms — see design-system.md "Motion" */
  function watchReveals() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.setProperty('--d', String(en.target.dataset.d || 0));
        en.target.classList.add('wf-reveal');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    var tick = function () {
      document.querySelectorAll('[data-reveal]:not(.wf-reveal)').forEach(function (el, i) {
        el.dataset.d = String(i % 4);
        io.observe(el);
      });
    };
    tick();
    setTimeout(tick, 400);
  }

  function burger() {
    var btn = document.querySelector('[data-wf-burger]');
    var nav = document.getElementById('wf-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Drawer: <details> already opens, closes and takes focus on its own. These
     are the two behaviours it does not give you — Escape, and a click on the
     page behind. Nothing here is required for the menu to work. */
  function drawer() {
    var d = document.querySelector('[data-wf-drawer]');
    if (!d) return;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) {
        d.open = false;
        var s = d.querySelector('summary');
        if (s) s.focus();
      }
    });
    d.addEventListener('click', function (e) {
      if (e.target.matches('[data-wf-drawer-scrim]')) d.open = false;
    });
  }

  /* product gallery: thumbnails swap the main image */
  function gallery() {
    var main = document.querySelector('[data-wf-main-image]');
    if (!main) return;
    document.querySelectorAll('[data-wf-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (!src) return;
        main.setAttribute('src', src);
        main.removeAttribute('srcset');
        document.querySelectorAll('[data-wf-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  function qty() {
    document.querySelectorAll('[data-wf-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    });
  }

  /* Delivery, returns and the FAQ are the pages people print, and a closed
     <details> prints as a heading with nothing under it. CSS cannot force one
     open in Chrome — display on the children does not reach the hidden slot —
     so the accordions are opened for the print job and put back afterwards. */
  function printableAccordions() {
    var opened = [];
    if (!window.matchMedia) return;
    var open = function () {
      opened = [].slice.call(document.querySelectorAll('details:not([open])'));
      opened.forEach(function (d) { d.open = true; });
    };
    var close = function () {
      opened.forEach(function (d) { d.open = false; });
      opened = [];
    };
    window.addEventListener('beforeprint', open);
    window.addEventListener('afterprint', close);
    /* Safari fires neither event; it flips this media query instead. */
    var mq = window.matchMedia('print');
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { e.matches ? open() : close(); });
    }
  }

  /* The collection sort control. The form works on its own — there is a submit
     button behind <noscript> — so this only removes the second click. */
  function autosubmit() {
    document.querySelectorAll('[data-wf-autosubmit]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchReveals();
    burger();
    drawer();
    gallery();
    qty();
    printableAccordions();
    autosubmit();
  });
})();
